var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5303 11.2197C19.8232 11.5126 19.8232 11.9874 19.5303 12.2803L13.5303 18.2803C13.2374 18.5732 12.7626 18.5732 12.4697 18.2803C12.1768 17.9874 12.1768 17.5126 12.4697 17.2197L17.9393 11.75L12.4697 6.28033C12.1768 5.98744 12.1768 5.51256 12.4697 5.21967C12.7626 4.92678 13.2374 4.92678 13.5303 5.21967L19.5303 11.2197Z",
    fill: "#38393D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2803 11.2197C13.5732 11.5126 13.5732 11.9874 13.2803 12.2803L7.28033 18.2803C6.98744 18.5732 6.51256 18.5732 6.21967 18.2803C5.92678 17.9874 5.92678 17.5126 6.21967 17.2197L11.6893 11.75L6.21967 6.28033C5.92678 5.98744 5.92678 5.51256 6.21967 5.21967C6.51256 4.92678 6.98744 4.92678 7.28033 5.21967L13.2803 11.2197Z",
    fill: "#38393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDouble);
export default __webpack_public_path__ + "static/media/arrow-double.c730a98aa2534d8bf1ab7048e1045a6f.svg";
export { ForwardRef as ReactComponent };